import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import AnimatedElement from "../AnimatedElement";

import "../../i18next";
import videoSrc from "../../assets/images/nosotros_section_2.mov";

function Nosotros2() {
  const { t } = useTranslation();
  const videoRef = useRef(null);
  const [isIOS, setIsIOS] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    const ua = navigator.userAgent;
    const isIOSDevice =
      /iPad|iPhone|iPod/.test(ua) &&
      /Safari/.test(ua) &&
      !/CriOS/.test(ua) &&
      !/FxiOS/.test(ua);

    setIsIOS(isIOSDevice);
  }, []);

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };

  return (
    <section className="relative flex flex-col lg:flex-row p-4 lg:p-16 md:gap-10">
      {/* Texto + Logos */}
      <div className="w-full lg:w-1/2 space-y-6">
        <AnimatedElement
          fromDirection="top"
          className="flex flex-col lg:flex-row items-start gap-6"
        >
          <p
            className="text-base sm:text-lg md:text-2xl lg:text-4xl font-bold title-school"
            style={{ fontFamily: "Helvetica" }}
          >
            {t("aboutUs.text2")}
          </p>
        </AnimatedElement>

        <AnimatedElement
          fromDirection="left"
          className="font-bold text-5xl sm:text-6xl lg:text-[8rem] text-orange-600 leading-none"
          style={{ fontFamily: "Helvetica" }}
        >
          {t("aboutUs.title1")}
        </AnimatedElement>

        <AnimatedElement
          fromDirection="left"
          className="font-bold text-5xl sm:text-6xl lg:text-[8rem] text-orange-600 leading-none"
          style={{ fontFamily: "Helvetica" }}
        >
          {t("aboutUs.title2")}
        </AnimatedElement>

        <AnimatedElement
          fromDirection="left"
          className="text-sm sm:text-base md:text-lg lg:text-2xl font-medium text-customDarkBlue"
          style={{ fontFamily: "Helvetica Neue" }}
        >
          {t("aboutUs.text3")}
        </AnimatedElement>
      </div>

      {/* Video */}
      <AnimatedElement
        fromDirection="right"
        className="w-full lg:w-1/2 md:mt-10 lg:mt-0 relative"
      >
        <video
          ref={videoRef}
          className="w-full h-auto rounded-xl"
          src={videoSrc}
          loop
          muted
          playsInline
          autoPlay={!isIOS}
        />
        {isIOS && !isPlaying && (
          <button
            onClick={handlePlay}
            className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  text-black text-3xl px-6 py-3 rounded-full z-10"
          >
            ▶
          </button>
        )}
      </AnimatedElement>
    </section>
  );
}

export default Nosotros2;
